const RIPPLE_CLASS = 'ripple-container'
const RIPPLE_EFFECT_CLASS = 'ripple-effect'

const createRipple = (event, el) => {
  const rect = el.getBoundingClientRect()
  const size = Math.max(rect.width, rect.height)
  const ripple = document.createElement('span')
  ripple.className = RIPPLE_EFFECT_CLASS
  ripple.style.width = ripple.style.height = `${size}px`
  ripple.style.left = `${event.clientX - rect.left - size / 2}px`
  ripple.style.top = `${event.clientY - rect.top - size / 2}px`
  el.appendChild(ripple)
  setTimeout(() => {
    ripple.remove()
  }, 450)
}

const attachHandler = (el) => {
  el.__rippleHandler__ = (event) => {
    if (el.__rippleDisabled__) return
    if (event.button !== 0) return
    createRipple(event, el)
  }
  el.addEventListener('pointerdown', el.__rippleHandler__)
}

const detachHandler = (el) => {
  if (el.__rippleHandler__) {
    el.removeEventListener('pointerdown', el.__rippleHandler__)
    delete el.__rippleHandler__
  }
}

export default {
  mounted(el, binding) {
    el.classList.add(RIPPLE_CLASS)
    el.__rippleDisabled__ = binding.value === false
    attachHandler(el)
  },
  updated(el, binding) {
    el.__rippleDisabled__ = binding.value === false
  },
  unmounted(el) {
    detachHandler(el)
  },
}
